import { Outlet } from 'react-router-dom';
import Header from './header';

const Root = () => {
    return (
        <div className="app-container">
            <Header></Header>
            <Outlet />
        </div>
    );
};

export default Root;
